import * as Yup from "yup";

export const mintNftDescriptionSchema = Yup.object().shape({
  NftTitle: Yup.string().required(),
  Description: Yup.string().required(),
});
